module.exports = __webpack_public_path__ + "static/media/condenasttraveler.746bc798.png";